import r from "../../managers/braze-instance.js";
import { destroyFeedHtml as ee } from "../../common/feed-display.js";
export function hideContentCards(e) {
  if (!r.rr()) return;
  const n = document.querySelectorAll(".ab-feed");
  for (let o = 0; o < n.length; o++)
    (null == e || (null != e && n[o].parentNode === e)) && ee(n[o]);
}
